const Panel = ({children, className, ...props}) => {
    return(
        <div className={`w-full p-[15px] rounded-[16px] bg-white overflow-x-auto ${className}`} {...props}>
            {children}
        </div>
    )
}

export default Panel;